// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.investments-container {
    width: 100%;
    margin: 0 auto;
    padding: 0 0 150px;
    overflow-y: scroll;
    height: 88vh;
    padding-right: 10px;
}

.investments-container > div {
    background-color: #0e0f15;
    color: white;
    width: 100%;
    border: 2px solid #f09502;
    padding: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
}

.investments-container .noProyects {
    display: flex;
    justify-content: center;
    align-items: center;
}

.investments-container > div:hover {
    background-color: #07070a;
    cursor: grab;
}

.investments-container .noProyects:hover {
    background-color: #0e0f15;
    cursor: auto;
}

.investments-container .cimg {
    width: 30%;
    padding: 0 20px 0 0;
}

.investments-container .cimg img {
    max-width: 100%;
    height: auto;
}

.investments-container .cinfo {
    width: 70%;
}

.investments-container table tr {
    line-height: 25px;
}

.investments-container table td {
    vertical-align: middle;
}

.investments-container .cinfo .documentation a {
    margin-right: 18px;
    color: white;
}

.investments-container a {
    text-decoration: none;
}

.investments-container .bi {
    margin-right: 8px;
}

.investments-container .cdata {
    width: 100%;
    border-top: 1px solid rgb(114, 114, 114);
    padding-top: 15px;
}

.investments-container .reinvertBtn {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: stretch;
    flex-wrap: wrap;
}

.investments-container .reinvertBtn input {
    margin-right: 15px;
    max-width: 200px;
}

.investments-container .wexpand {
    width: 50%;
    margin: 0 auto;
}

.modal .modal-content {
    background-color: #181b25;
}

.modal .modal-content > * {
    width: 85%;
    margin: 0 auto;
}

.modal-header {
    border-bottom: 2px solid #f09502;
}

.reinvestment {
    width: 100%;
    border-bottom: 1px solid gray;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
}

.reinvestment .containerImg {
    width: 40%;
}

.reinvestment .containerImg img {
    width: 100%;
    height: auto;
}

.reinvestment .data {
    width: 60%;
    padding: 0 2%;
}

.reinvestment .data .documentation a {
    margin-right: 18px;
}

.reinvestment .data .documentation a:hover {
    cursor: pointer;
}

.reinvestment .data .documentation a:first-child {
    margin-right: 25px;
}

.reinvestment .data button {
    display: block;
    min-width: 40%;
    margin: 0 auto 0 0;
}

.reinvestment .data button i {
    margin-right: 8px;
}


.reinvestment .progressData {
    width: 100%;
}

.reinvestment .pdata {
    width: 100%;
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.reinvestment .pdata > div:first-child {
    width: 60%;
}

.reinvestment .pdata > div:last-child {
    width: 40%;
    text-align: right;
}

.btn-outline-success:disabled {
    color: #f09502;
    border-color: #f09502;
}

.investments-container .reinvertirBtn {
    margin-right: 8px;
}

tr.toClaim td{
    color: #689F38 !important;
    font-weight: 800;
}

tr.claimed td{
    color: #9E9E9E !important;
    font-weight: 800;
}

.investments-container .directTokens:hover {
    cursor: default;
}

.investments-container .companyTokens:hover {
    cursor: pointer;
}

@media (max-width: 500px) {
    .investments-container {
        width: 98%;
        margin: 0 auto;
    }

    .investments-container > div {
        padding: 15px;
    }

    .investments-container .cimg {
        width: 100%;
        padding: 0 0 0 0;
        margin-bottom: 20px;
    }

    .investments-container .cinfo {
        width: 100%;
    }

    .investments-container .cdata {
        margin-bottom: 15px !important;
    }

    .investments-container .reinvertBtn button {
        width: 100%;
    }

    .investments-container .reinvertBtn input {
        margin-right: 0;
        max-width: 100%;
        width: 100%;
        margin-bottom: 8px;
    }

    .investments-container .wexpand {
        width: 100%;
    }

    .modal .modal-content > * {
        width: 95%;
    }

    .reinvestment:first-child {
        padding-top: 15px !important;
    }

    .reinvestment .containerImg {
        width: 100%;
    }

    .reinvestment .containerImg .progressData {
        margin-bottom: 25px;
    }
    
    .reinvestment .data {
        width: 100%;
        padding: 0;
    }

    .reinvestment .data button {
        min-width: 100%;
        margin: 0 auto;
        padding: 15px;
    }

    .investments-container .modal-body {
        padding: 5px;
    }

    .investments-container .cinfo .documentation a, .reinvestment .data .documentation a {
        display: block;
        width: 100%;
        margin-bottom: 5px;
        margin-right: 0;
    }
    .info-span-mobile{
        font-size: 1rem !important;
    }
}

.scrollable-container {
    max-height: 90vh !important; /* Ajusta la altura máxima según tus necesidades */
}

/* Personaliza el scroll */
.scrollable-container::-webkit-scrollbar {
    width: 12px; /* Ancho del scroll */
}

.scrollable-container::-webkit-scrollbar-track {
    background: #f1f1f1; /* Color de fondo del track del scroll */
    border-radius: 10px; /* Bordes redondeados del track */
    border: 1px solid #F09502; /* Borde del track del scroll */
}

.scrollable-container::-webkit-scrollbar-thumb {
    background: #F09502; /* Color del thumb del scroll */
    border-radius: 10px; /* Bordes redondeados del thumb */
    border: 1px solid #f1f1f1; /* Borde del thumb del scroll */
}

.scrollable-container::-webkit-scrollbar-thumb:hover {
    background: #d48402; /* Color del thumb del scroll al pasar el mouse */
}

.scrollable-container::-webkit-scrollbar, .scrollable-container::-webkit-scrollbar {
    width: 12px !important; /* Ancho del scroll */
}

/* Ocultar la barra de desplazamiento en dispositivos móviles y tabletas */
@media (max-width: 768px) {
    .scrollable-container::-webkit-scrollbar {
      display: none;
    }
    .scrollable-container {
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
      padding-right: 0 !important;
    }
  }

/* Estilos generales para la sección de referidos */
.referral-container {
    margin-top: 1rem;
    margin-bottom: 2rem;
}

/* Ajusta el contenedor del botón para centrarlo */
.referral-button-container {
    margin: 0 auto;
    max-width: 18.75rem; /* 300px */
}

/* Estilos del título de referidos */
.referral-title {
    font-size: 1.5rem;
    font-style: italic;
    margin-bottom: 1rem;
    margin-top: 2rem;
    position: relative;
    top: 0.5rem;
}

/* Estilos del botón */
.referral-button {
    background-color: #f09502;
    color: white;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    font-weight: bold;
    text-transform: uppercase;
    width: 100%;
}

/* Media queries para ajustar el diseño en diferentes dispositivos */

/* Pantallas pequeñas: teléfonos móviles */
@media (max-width: 600px) {
    .referral-title {
        margin-bottom: 2rem !important;
        font-size: 1.2rem !important;
    }
}

/* Pantallas medianas: tabletas y dispositivos entre 600px y 900px */
@media (min-width: 601px) and (max-width: 900px) {
    .referral-title {
        margin-bottom: 3rem !important;
        font-size: 1.4rem !important;
    }
}

/* Pantallas grandes: laptops y dispositivos entre 900px y 1200px */
@media (min-width: 901px) and (max-width: 1200px) {
    .referral-title {
        margin-bottom: 2.5rem !important;
        font-size: 1.5rem !important;
    }
}

/* Pantallas extra grandes: monitores de más de 1200px */
@media (min-width: 1201px) {
    .referral-title {
        margin-bottom: 2rem !important;
        font-size: 1.6rem !important;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/components/user-investments/user-investments.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,eAAe;QACf,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,eAAe;QACf,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,2BAA2B,EAAE,kDAAkD;AACnF;;AAEA,0BAA0B;AAC1B;IACI,WAAW,EAAE,qBAAqB;AACtC;;AAEA;IACI,mBAAmB,EAAE,wCAAwC;IAC7D,mBAAmB,EAAE,iCAAiC;IACtD,yBAAyB,EAAE,+BAA+B;AAC9D;;AAEA;IACI,mBAAmB,EAAE,+BAA+B;IACpD,mBAAmB,EAAE,iCAAiC;IACtD,yBAAyB,EAAE,+BAA+B;AAC9D;;AAEA;IACI,mBAAmB,EAAE,iDAAiD;AAC1E;;AAEA;IACI,sBAAsB,EAAE,qBAAqB;AACjD;;AAEA,0EAA0E;AAC1E;IACI;MACE,aAAa;IACf;IACA;MACE,wBAAwB,GAAG,gBAAgB;MAC3C,qBAAqB,GAAG,YAAY;MACpC,2BAA2B;IAC7B;EACF;;AAEF,mDAAmD;AACnD;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,kDAAkD;AAClD;IACI,cAAc;IACd,mBAAmB,EAAE,UAAU;AACnC;;AAEA,oCAAoC;AACpC;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;AACf;;AAEA,oEAAoE;;AAEpE,0CAA0C;AAC1C;IACI;QACI,8BAA8B;QAC9B,4BAA4B;IAChC;AACJ;;AAEA,oEAAoE;AACpE;IACI;QACI,8BAA8B;QAC9B,4BAA4B;IAChC;AACJ;;AAEA,mEAAmE;AACnE;IACI;QACI,gCAAgC;QAChC,4BAA4B;IAChC;AACJ;;AAEA,wDAAwD;AACxD;IACI;QACI,8BAA8B;QAC9B,4BAA4B;IAChC;AACJ","sourcesContent":[":host {\n    width: 100%;\n}\n\n.investments-container {\n    width: 100%;\n    margin: 0 auto;\n    padding: 0 0 150px;\n    overflow-y: scroll;\n    height: 88vh;\n    padding-right: 10px;\n}\n\n.investments-container > div {\n    background-color: #0e0f15;\n    color: white;\n    width: 100%;\n    border: 2px solid #f09502;\n    padding: 40px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.investments-container .noProyects {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.investments-container > div:hover {\n    background-color: #07070a;\n    cursor: grab;\n}\n\n.investments-container .noProyects:hover {\n    background-color: #0e0f15;\n    cursor: auto;\n}\n\n.investments-container .cimg {\n    width: 30%;\n    padding: 0 20px 0 0;\n}\n\n.investments-container .cimg img {\n    max-width: 100%;\n    height: auto;\n}\n\n.investments-container .cinfo {\n    width: 70%;\n}\n\n.investments-container table tr {\n    line-height: 25px;\n}\n\n.investments-container table td {\n    vertical-align: middle;\n}\n\n.investments-container .cinfo .documentation a {\n    margin-right: 18px;\n    color: white;\n}\n\n.investments-container a {\n    text-decoration: none;\n}\n\n.investments-container .bi {\n    margin-right: 8px;\n}\n\n.investments-container .cdata {\n    width: 100%;\n    border-top: 1px solid rgb(114, 114, 114);\n    padding-top: 15px;\n}\n\n.investments-container .reinvertBtn {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    align-items: stretch;\n    flex-wrap: wrap;\n}\n\n.investments-container .reinvertBtn input {\n    margin-right: 15px;\n    max-width: 200px;\n}\n\n.investments-container .wexpand {\n    width: 50%;\n    margin: 0 auto;\n}\n\n.modal .modal-content {\n    background-color: #181b25;\n}\n\n.modal .modal-content > * {\n    width: 85%;\n    margin: 0 auto;\n}\n\n.modal-header {\n    border-bottom: 2px solid #f09502;\n}\n\n.reinvestment {\n    width: 100%;\n    border-bottom: 1px solid gray;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.reinvestment .containerImg {\n    width: 40%;\n}\n\n.reinvestment .containerImg img {\n    width: 100%;\n    height: auto;\n}\n\n.reinvestment .data {\n    width: 60%;\n    padding: 0 2%;\n}\n\n.reinvestment .data .documentation a {\n    margin-right: 18px;\n}\n\n.reinvestment .data .documentation a:hover {\n    cursor: pointer;\n}\n\n.reinvestment .data .documentation a:first-child {\n    margin-right: 25px;\n}\n\n.reinvestment .data button {\n    display: block;\n    min-width: 40%;\n    margin: 0 auto 0 0;\n}\n\n.reinvestment .data button i {\n    margin-right: 8px;\n}\n\n\n.reinvestment .progressData {\n    width: 100%;\n}\n\n.reinvestment .pdata {\n    width: 100%;\n    display: flex !important;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.reinvestment .pdata > div:first-child {\n    width: 60%;\n}\n\n.reinvestment .pdata > div:last-child {\n    width: 40%;\n    text-align: right;\n}\n\n.btn-outline-success:disabled {\n    color: #f09502;\n    border-color: #f09502;\n}\n\n.investments-container .reinvertirBtn {\n    margin-right: 8px;\n}\n\ntr.toClaim td{\n    color: #689F38 !important;\n    font-weight: 800;\n}\n\ntr.claimed td{\n    color: #9E9E9E !important;\n    font-weight: 800;\n}\n\n.investments-container .directTokens:hover {\n    cursor: default;\n}\n\n.investments-container .companyTokens:hover {\n    cursor: pointer;\n}\n\n@media (max-width: 500px) {\n    .investments-container {\n        width: 98%;\n        margin: 0 auto;\n    }\n\n    .investments-container > div {\n        padding: 15px;\n    }\n\n    .investments-container .cimg {\n        width: 100%;\n        padding: 0 0 0 0;\n        margin-bottom: 20px;\n    }\n\n    .investments-container .cinfo {\n        width: 100%;\n    }\n\n    .investments-container .cdata {\n        margin-bottom: 15px !important;\n    }\n\n    .investments-container .reinvertBtn button {\n        width: 100%;\n    }\n\n    .investments-container .reinvertBtn input {\n        margin-right: 0;\n        max-width: 100%;\n        width: 100%;\n        margin-bottom: 8px;\n    }\n\n    .investments-container .wexpand {\n        width: 100%;\n    }\n\n    .modal .modal-content > * {\n        width: 95%;\n    }\n\n    .reinvestment:first-child {\n        padding-top: 15px !important;\n    }\n\n    .reinvestment .containerImg {\n        width: 100%;\n    }\n\n    .reinvestment .containerImg .progressData {\n        margin-bottom: 25px;\n    }\n    \n    .reinvestment .data {\n        width: 100%;\n        padding: 0;\n    }\n\n    .reinvestment .data button {\n        min-width: 100%;\n        margin: 0 auto;\n        padding: 15px;\n    }\n\n    .investments-container .modal-body {\n        padding: 5px;\n    }\n\n    .investments-container .cinfo .documentation a, .reinvestment .data .documentation a {\n        display: block;\n        width: 100%;\n        margin-bottom: 5px;\n        margin-right: 0;\n    }\n    .info-span-mobile{\n        font-size: 1rem !important;\n    }\n}\n\n.scrollable-container {\n    max-height: 90vh !important; /* Ajusta la altura máxima según tus necesidades */\n}\n\n/* Personaliza el scroll */\n.scrollable-container::-webkit-scrollbar {\n    width: 12px; /* Ancho del scroll */\n}\n\n.scrollable-container::-webkit-scrollbar-track {\n    background: #f1f1f1; /* Color de fondo del track del scroll */\n    border-radius: 10px; /* Bordes redondeados del track */\n    border: 1px solid #F09502; /* Borde del track del scroll */\n}\n\n.scrollable-container::-webkit-scrollbar-thumb {\n    background: #F09502; /* Color del thumb del scroll */\n    border-radius: 10px; /* Bordes redondeados del thumb */\n    border: 1px solid #f1f1f1; /* Borde del thumb del scroll */\n}\n\n.scrollable-container::-webkit-scrollbar-thumb:hover {\n    background: #d48402; /* Color del thumb del scroll al pasar el mouse */\n}\n\n.scrollable-container::-webkit-scrollbar, .scrollable-container::-webkit-scrollbar {\n    width: 12px !important; /* Ancho del scroll */\n}\n\n/* Ocultar la barra de desplazamiento en dispositivos móviles y tabletas */\n@media (max-width: 768px) {\n    .scrollable-container::-webkit-scrollbar {\n      display: none;\n    }\n    .scrollable-container {\n      -ms-overflow-style: none;  /* IE and Edge */\n      scrollbar-width: none;  /* Firefox */\n      padding-right: 0 !important;\n    }\n  }\n\n/* Estilos generales para la sección de referidos */\n.referral-container {\n    margin-top: 1rem;\n    margin-bottom: 2rem;\n}\n\n/* Ajusta el contenedor del botón para centrarlo */\n.referral-button-container {\n    margin: 0 auto;\n    max-width: 18.75rem; /* 300px */\n}\n\n/* Estilos del título de referidos */\n.referral-title {\n    font-size: 1.5rem;\n    font-style: italic;\n    margin-bottom: 1rem;\n    margin-top: 2rem;\n    position: relative;\n    top: 0.5rem;\n}\n\n/* Estilos del botón */\n.referral-button {\n    background-color: #f09502;\n    color: white;\n    font-size: 1rem;\n    padding: 0.5rem 1rem;\n    border-radius: 0.25rem;\n    font-weight: bold;\n    text-transform: uppercase;\n    width: 100%;\n}\n\n/* Media queries para ajustar el diseño en diferentes dispositivos */\n\n/* Pantallas pequeñas: teléfonos móviles */\n@media (max-width: 600px) {\n    .referral-title {\n        margin-bottom: 2rem !important;\n        font-size: 1.2rem !important;\n    }\n}\n\n/* Pantallas medianas: tabletas y dispositivos entre 600px y 900px */\n@media (min-width: 601px) and (max-width: 900px) {\n    .referral-title {\n        margin-bottom: 3rem !important;\n        font-size: 1.4rem !important;\n    }\n}\n\n/* Pantallas grandes: laptops y dispositivos entre 900px y 1200px */\n@media (min-width: 901px) and (max-width: 1200px) {\n    .referral-title {\n        margin-bottom: 2.5rem !important;\n        font-size: 1.5rem !important;\n    }\n}\n\n/* Pantallas extra grandes: monitores de más de 1200px */\n@media (min-width: 1201px) {\n    .referral-title {\n        margin-bottom: 2rem !important;\n        font-size: 1.6rem !important;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
